export default __webpack_public_path__ + "static/media/ISR 2024 Bulletin.814b1050.pdf";